import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PublicURL } from "../../../routes/public_routes/PublicURL";

const Footer = () => {
    const brandName = process.env.REACT_APP_BRAND_NAME;
    const navigate = useNavigate();

    return (
        <footer
            className="
                tw-relative
                tw-bg-[#020617]
                tw-text-gray-300
                tw-py-16
                tw-px-6
                tw-overflow-hidden
            "
        >
            {/* Background glow */}

            <motion.div
                animate={{ opacity: [0.15, 0.3, 0.15] }}
                transition={{
                    duration: 6,
                    repeat: Infinity,
                }}
                className="
                    tw-absolute
                    tw-top-0
                    tw-left-1/2
                    -tw-translate-x-1/2
                    tw-w-[500px]
                    tw-h-[200px]
                    tw-bg-blue-500/20
                    tw-blur-[100px]
                "
            />

            <div
                className="
                    tw-relative
                    tw-z-10
                    tw-max-w-7xl
                    tw-mx-auto
                "
            >
                <div
                    className="
                        tw-grid
                        md:tw-grid-cols-4
                        tw-gap-10
                    "
                >
                    {/* Brand */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h3
                            className="
                                tw-text-2xl
                                tw-font-bold
                                tw-text-white
                                tw-mb-4
                            "
                        >
                            {brandName}
                        </h3>

                        <p
                            className="
                                tw-text-sm
                                tw-leading-relaxed
                                tw-text-gray-400
                            "
                        >
                            The intelligent operating system helping CA firms automate operations, improve visibility and focus on higher-value work.
                        </p>
                    </motion.div>

                    {/* Platform */}

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.15 }}
                    >
                        <h4
                            className="
                                tw-text-white
                                tw-font-semibold
                                tw-mb-5
                            "
                        >
                            Platform
                        </h4>

                        <ul
                            className="
                                tw-space-y-3
                                tw-text-sm
                                tw-pl-3
                            "
                        >
                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                    tw-transition
                                "
                                onClick={ () => navigate(PublicURL.AUTOMATION) }
                            >
                                Automation
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                    tw-transition
                                "
                                onClick={ () => navigate(PublicURL.WORKFLOWS) }
                            >
                                Workflows
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                    tw-transition
                                "
                                onClick={ () => navigate(PublicURL.ANALYTICS) }
                            >
                                Analytics
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                    tw-transition
                                "
                                onClick={ () => navigate(PublicURL.INTEGRATIONS) }
                            >
                                Integrations
                            </li>
                        </ul>
                    </motion.div>

                    {/* Company */}

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 }}
                    >
                        <h4
                            className="
                                tw-text-white
                                tw-font-semibold
                                tw-mb-5
                            "
                        >
                            Company
                        </h4>

                        <ul
                            className="
                                tw-space-y-3
                                tw-text-sm
                                tw-pl-3
                            "
                        >
                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                "
                                onClick={ () => navigate(PublicURL.VISION) }
                            >
                                Vision
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                "
                                onClick={ () => navigate(PublicURL.ABOUT) }
                            >
                                About
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                "
                                onClick={ () => navigate(PublicURL.CONTACT_US) }
                            >
                                Contact
                            </li>

                            <li
                                className="
                                    hover:tw-text-cyan-400
                                    tw-cursor-pointer
                                "
                                onClick={ () => navigate(PublicURL.CAREERS) }
                            >
                                Careers
                            </li>
                        </ul>
                    </motion.div>

                    {/* CTA */}

                    <motion.div
                        initial={{opacity: 0, y: 30}}
                        whileInView={{opacity: 1, y: 0}}
                        viewport={{ once: true }}
                        transition={{ delay: 0.45 }}
                    >
                        <h4
                            className="
                                tw-text-white
                                tw-font-semibold
                                tw-mb-5
                            "
                        >
                            Start Building
                        </h4>

                        <p
                            className="
                                tw-text-sm
                                tw-text-gray-400
                                tw-mb-5
                            "
                        >
                            Give your accountants the tools to focus on meaningful work.
                        </p>

                        <button
                            className="
                                tw-px-5
                                tw-py-3
                                tw-rounded-xl
                                tw-bg-blue-600
                                hover:tw-bg-blue-500
                                tw-text-white
                                tw-font-semibold
                                tw-transition
                            "
                        >
                            Request Demo
                        </button>
                    </motion.div>
                </div>

                {/* Divider */}
                <div
                    className="
                        tw-mt-14
                        tw-pt-8
                        tw-border-t
                        tw-border-white/10
                        tw-flex
                        tw-flex-col
                        md:tw-flex-row
                        tw-justify-between
                        tw-gap-4
                        tw-text-sm
                        tw-text-gray-500
                    "
                >
                    <p>© {new Date().getFullYear()} {brandName}. All rights reserved.</p>

                    <p>Built for the next generation of CA firms.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;